import React from "react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/Primitives";
import { Button } from "@/components/ui/button";
import { UserPlus, Share2, LineChart, BadgeIndianRupee, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: UserPlus, t: "Register as a partner", d: "Create a free partner account and accept the referral terms." },
  { icon: Share2, t: "Share your unique link", d: "Introduce a business (with their permission) using your personal referral link or code." },
  { icon: LineChart, t: "Track the progress", d: "Follow each referral's status from submitted to qualified to won — privately." },
  { icon: BadgeIndianRupee, t: "Earn when it qualifies", d: "Earn commission when the stated payment and approval conditions are met." },
];

export default function ReferEarnSection() {
  return (
    <section className="py-24 relative" data-testid="refer-earn-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="glass-strong rounded-3xl p-8 sm:p-14 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-violet-600/20 blur-3xl" />
          <div className="relative">
            <SectionHeading
              eyebrow="Refer & Earn"
              title="Refer a Business. Earn When Their Website Project Qualifies."
              subtitle="Know a local business that needs a premium website? Introduce them and earn a commission once their project is won and payment is verified."
            />
            <div className="grid grid-cols-1 md:grid-cols-4 gap-5 mt-4">
              {STEPS.map((s, i) => (
                <Reveal key={s.t} delay={i * 0.08}>
                  <div className="glass rounded-2xl p-6 card-hover h-full">
                    <span className="grid place-items-center w-11 h-11 rounded-xl bg-violet-500/20 text-violet-300 mb-4"><s.icon className="w-5 h-5" /></span>
                    <div className="text-xs font-mono text-cyan-300 mb-1">Step {i + 1}</div>
                    <h3 className="font-semibold text-white mb-2">{s.t}</h3>
                    <p className="text-sm text-slate-400 leading-relaxed">{s.d}</p>
                  </div>
                </Reveal>
              ))}
            </div>
            <p className="text-xs text-slate-500 mt-6">Commission is never promised merely for submitting a contact. Final payout depends on verified payment and admin approval under the referral terms.</p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <Link to="/partner/register"><Button data-testid="refer-signup-cta" className="bg-violet-600 hover:bg-violet-500 text-white font-semibold btn-glow">Become a Partner <ArrowRight className="w-4 h-4 ml-2" /></Button></Link>
              <Link to="/refer-earn"><Button variant="outline" className="border-white/15 bg-transparent text-white hover:bg-white/10">Learn how it works</Button></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
